import {createSlice} from '@reduxjs/toolkit'

// AGENCY DETAILS THAT ARE BEING VIEWED ON ROUTE -> /agency/:id and /agency/:id/ts/:tsID
const agencySlice = createSlice({
    name: 'agency',
    initialState: {
        data: null
    },
    reducers: {
        setAgencySliceData: (state, action) => {
            state.data = action.payload
        },
        clearAgencySliceData: state => {
            state.data = null
        }
    }
})

export const {setAgencySliceData, clearAgencySliceData} = agencySlice.actions
export default agencySlice.reducer;
